import { useAtomValue } from 'jotai';
import { unwrappedComparisonTeamNameAtom } from '@/atoms/queries/team/teamComparison';
import { unwrappedSelectedTeamNameAtom } from '@/atoms/team/info';
import { EntityMetricPreview } from '@/components/preview/EntityMetricPreview';
import { COMPARISON_ID } from '@/consts/searchKeys';
import { useQueryParam } from '@/hooks/useQueryParam';
import { TeamComparisonPreviewPanel } from './TeamComparisonPreviewPanel';
import { TeamPrimaryPreviewPanel } from './TeamPrimaryPreviewPanel';

export const TeamPreview = () => {
  const comparisonId = useQueryParam(COMPARISON_ID);
  const primaryLabel = useAtomValue(unwrappedSelectedTeamNameAtom);
  const comparisonLabel = useAtomValue(unwrappedComparisonTeamNameAtom);

  return (
    <EntityMetricPreview
      entity="team"
      primaryLabel={primaryLabel}
      comparisonLabel={comparisonLabel}
      primaryPanel={<TeamPrimaryPreviewPanel />}
      comparisonPanel={comparisonId ? <TeamComparisonPreviewPanel /> : undefined}
    />
  );
};

export default TeamPreview;
